import { render } from "./WeDeclareWar.vue?vue&type=template&id=e70a4764&scoped=true"
import script from "./WeDeclareWar.vue?vue&type=script&lang=js"
export * from "./WeDeclareWar.vue?vue&type=script&lang=js"

import "./WeDeclareWar.vue?vue&type=style&index=0&id=e70a4764&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70a4764"]])

export default __exports__